import { render, staticRenderFns } from "./createProblem.vue?vue&type=template&id=a2dbf300&scoped=true"
import script from "./createProblem.vue?vue&type=script&lang=js"
export * from "./createProblem.vue?vue&type=script&lang=js"
import style0 from "./createProblem.vue?vue&type=style&index=0&id=a2dbf300&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dbf300",
  null
  
)

export default component.exports